import { setupKeys, decryptAESKey } from '../src/component/Crypto_Helpers/cryptoHelper'
import Axios from "axios";

// encryptionSession.js
let AES_SESSION_KEY = null;
let RSA_PRIVATE_KEY = null;

export async function initEncryptionSession() {
  if (AES_SESSION_KEY) return AES_SESSION_KEY;
  // Fetch AES key directly from server
  const API_URL = import.meta.env.VITE_API_URL;
  if (!API_URL) throw new Error('VITE_API_URL is not defined — check your .env file');
  const resp = await Axios.post(`${API_URL}admin/create-session`, { module: "C" });
  const aesKey = atob(resp.data.aesKeyBase64);
  // Store as Base64 string
  AES_SESSION_KEY = aesKey;

  return AES_SESSION_KEY;
}

function base64ToUtf8(base64) {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(base64), c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
}

export function aesKeyToBase64(aesKeyUint8) {
  return btoa(String.fromCharCode(...aesKeyUint8));
}

// Optional (on logout)
export function clearEncryptionSession() {
  AES_SESSION_KEY = null;
  RSA_PRIVATE_KEY = null;
}
